<template>
  <div id="pdfDom" class="qrCode">
    <el-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        title="打印"
        width="1300px"
        top="10vh">
      <div id="content">
        <div>
          <table
              cellpadding="0"
              cellspacing="0"
              border="1"
              style="width: 100%"
              class="table">
            <tr>
              <!--							<td style="text-align: center"><img src="../../../public/img/steplogo.png" style="width: 100px" /></td>-->
              <td colspan="6" style="text-align: center;font-size: 20px">售后服务材料单</td>
              <td colspan="2">
                <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                  <div style="display: flex;flex-direction: row;align-items: center;width: 50%">
                    <div style="padding: 0 10px">版本 :</div>
                    <div>D</div>
                  </div>
                  <div style="display: flex;flex-direction: row;align-items: center;width: 50%">
                    <div style="padding: 0 10px">修订 :</div>
                    <div>0</div>
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;align-items: center">
                  <div style="padding: 0 10px">编号 :</div>
                  <div>No.1</div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="text-align: center">售后单号</td>
              <td style="text-align: center" colspan="3">
                <!--								<div style="width: 80%;margin: 0 auto"><img src="../../../public/img/txm.png" style="width: 100%" /></div>-->
                <div style="font-size: 15px">{{model.billNo}}</div>
                <svg :id="'barcode' + model.billNo"/>
              </td>
              <td style="text-align: center;width: 120px">办事处</td>
              <td style="text-align: center">{{model.departmentName}}</td>
              <td style="text-align: center;width: 120px">登记人</td>
              <td style="text-align: center">{{model.creatorName}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">销售员</td>
              <td style="text-align: center" colspan="3">{{model.salesName}}/{{model.departmentName}}</td>
              <td style="text-align: center;width: 120px">销售联系方式</td>
              <td style="text-align: center" colspan="3">{{model.salesMobile}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">合同单位</td>
              <td style="text-align: center" colspan="3">{{model.customerName}}</td>
              <td style="text-align: center;width: 120px">出厂编号</td>
              <td style="text-align: center">{{model.salesOrderNo}}</td>
              <td style="text-align: center;width: 120px">已过维修期</td>
              <td style="text-align: center">{{model.underWarranty ? '是' : '否'}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">现场名称</td>
              <td style="text-align: center" colspan="3">{{model.siteName}}</td>
              <td style="text-align: center;width: 120px">现场联系方式</td>
              <td style="text-align: center">{{model.mobile}}</td>
              <td style="text-align: center;width: 120px">项目号</td>
              <td style="text-align: center">{{model.faultSerialNO}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">收货地址</td>
              <td style="text-align: center" colspan="3">{{model.deliveryAddress}}</td>
              <td style="text-align: center;width: 120px">收货人</td>
              <td style="text-align: center">{{model.consignee}}</td>
              <td style="text-align: center;width: 120px">收货联系方式</td>
              <td style="text-align: center">{{model.consigneeMobile}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">请求发货方式</td>
              <td style="text-align: center">{{model.deliveryType}}</td>
              <td style="text-align: center;width: 120px">请求发货日期</td>
              <td style="text-align: center">{{model.deliveryDate}}</td>
              <td style="text-align: center;width: 120px">是否到付</td>
              <td style="text-align: center">{{model.deliveryPaymentType ? '是' : '否'}}</td>
              <td style="text-align: center;width: 120px">联系邮箱</td>
              <td style="text-align: center">{{model.Email}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">客户投诉编号</td>
              <td style="text-align: center">{{model.customerBillNo}}</td>
              <td style="text-align: center;width: 120px">退件快递单号</td>
              <td style="text-align: center">{{model.tujianNo}}</td>
              <td style="text-align: center;width: 120px">退回日期</td>
              <td style="text-align: center">{{model.backTime}}</td>
              <td style="text-align: center;width: 120px">提交时间</td>
              <td style="text-align: center">{{model.submitTime}}</td>
            </tr>
            <tr>
              <td colspan="8" style="height: 20px;"/>
            </tr>

            <tr>
              <td colspan="8" style="padding: 0">
                <table cellpadding="0" cellspacing="0" style="width: 100%">
                  <tr v-for="(item2, index) in handleDetailVos" :key="index">
                    <td colspan="8" style="padding: 10px;border-bottom: 1px solid #000">
                      <div>{{item2.nodeText}}：</div>
                      <div>{{item2.handleRemark}}</div>
                      <div style="width: 130px;float: right;display: flex;flex-direction: row;align-items: center">
                        <span style="display: block;width: 60px;">审核人：</span>
                        <span v-if="item2.handlerName" style="display: block;">{{item2.handlerName}}</span>
                        <span v-else style="display: block;">{{item2.nodeApproverVos[0].handlerName}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="8" style="padding: 10px">
                <div>描述问题：</div>
                <div style="text-indent: 27px">
                  {{model.note}}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="8" style="padding: 0">
                <table cellpadding="0" cellspacing="0" style="width: 100%">
                  <tr>
                    <td style="text-align: center;border-right: 1px solid #000">物料号</td>
                    <td style="text-align: center;border-right: 1px solid #000" colspan="2">名称规格型号</td>
                    <td style="text-align: center;border-right: 1px solid #000">数量</td>
                    <td style="text-align: center;border-right: 1px solid #000">单位</td>
                    <td style="text-align: center;border-right: 1px solid #000">新程序</td>
                    <td style="text-align: center;border-right: 1px solid #000">发运处理人</td>
                    <td style="text-align: center;border-right: 1px solid #000">新旧品要求</td>
                    <td style="text-align: center">序列号/条形码</td>
                  </tr>
                  <tr v-for="(items, index) in model.details" :key="index">
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.materialNo}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000" colspan="2">{{items.materialDesc}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.quantity}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.unit}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.presentSoftware}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.deliveryPerson}}</td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      <span v-if="items.isNewRequest === 0">否</span>
                      <span v-else-if="items.isNewRequest === 1">是</span>
                      <span v-else>可新可旧</span>
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">{{items.mainPartsSerialNo}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <!--				<el-button @click="print">下载</el-button>-->
        <el-button type="primary" plain @click="print">打印</el-button>
        <el-button type="success" plain @click="exportBill">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import html2Canvas from "html2canvas";
  import JsPDF from "jspdf";
  import barCode from "jsbarcode";
  import moment from "moment";
  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        pageData: null, //接收html格式代码
        htmlTitle: "",
        handleDetailVos: [],
        model: {
          deliveryDate:"",
        },
      };
    },
    methods: {
      open(row) {
        this.model = row;
        this.model.deliveryDate = moment().format("YYYY-MM-DD");
        this.dialogVisible = true;
        this.getHandleDetailVos(row.pkid);
        this.$nextTick(() => {
          document.getElementById("barcode" + row.billNo).innerHTML = "";
          this.bindQRCode(row);
        });
      },
      getHandleDetailVos(id) {
        this.handleDetailVos = [];
        this.$http
          .get("basic", `applications/handle-detail/13/${id}`)
          .then(resp => {
            console.log(resp);
            let list = resp.handleDetailVos.reverse();
            let newList = [];
            if (list.length>3) {
              newList = list.slice(list.length-4,list.length);
            }else {
              newList = list;
            }
            for (let item of newList) {
              if (!item.handleRemark.includes("上级退回")) {
                if (item.nodeText === "售后审核" || item.nodeText === "售后复审" || item.nodeText === "售后确认") {
                  this.handleDetailVos.push(item);
                }
              }
            }
          });
      },
      bindQRCode(row) {
        console.log(row);
        new barCode("#barcode" + row.billNo, row.billNo, {
          displayValue: false, // 是否在条形码下方显示文字
          format: "CODE128",
          height: 30,
        });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
      exportBill() {
        // this.htmlTitle = this.model.billNo;
        // htmlToPdf.getPdf("#content", this.htmlTitle);
        let title = this.model.billNo;
        html2Canvas(document.querySelector("#content"), {
          allowTaint: true,
        }).then(function(canvas) {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(title + ".pdf");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.qrCode {
  .qrCode-div {
    page-break-after: always;
    .table {
      tr {
        td {
          font-size: 15px;
          padding: 10px;
        }
      }
    }
  }
}
</style>
